import React from "react";
import type { VersatileSelectorProps, NameLabelPair, Field } from "react-querybuilder";
import { CustomFieldSelector } from "./custom-field-selector";
import { formatMessage } from "lib/globalize-util";

export const CustomFieldDependantSelector: React.FunctionComponent<VersatileSelectorProps> = (props) => {
    const { options, fieldData, handleOnChange } = props;
    const { parent: initialParent, children: initialChildren } = props.value as any;
    const [selectedParentValue, setSelectedParentValue] = React.useState<string>(initialParent);
    const [childrenValues, setChildrenValues] = React.useState<NameLabelPair[]>(() => {
        const childrenForSelectedParent =
            (fieldData.values as Field[]).find((value) => value.name === initialParent)?.values ?? [];
        return childrenForSelectedParent as NameLabelPair[];
    });
    const [selectedChildrenValues, setSelectedChildrenValues] = React.useState<string[]>(initialChildren);

    const onChangeParent = React.useCallback(
        (newValue) => {
            setSelectedParentValue(newValue);
            const childrenForSelectedParent =
                (fieldData.values as Field[]).find((value) => value.name === newValue)?.values ?? [];
            setChildrenValues(childrenForSelectedParent as NameLabelPair[]);
            const values = childrenForSelectedParent.map((item) => item.value);
            setSelectedChildrenValues(values);
            handleOnChange({
                parent: newValue,
                children: values,
            });
        },
        [fieldData.values, handleOnChange]
    );

    const onChangeChildren = React.useCallback(
        (newValues) => {
            setSelectedChildrenValues(newValues);
            handleOnChange({
                parent: selectedParentValue,
                children: newValues,
            });
        },
        [handleOnChange, selectedParentValue]
    );

    return (
        <div className="rule dependant-fields">
            {/* @ts-ignore -- TODO: remove once "TS2589: Type instantiation is excessively deep and possibly infinite" is fixed in tsc */}
            <CustomFieldSelector
                {...props}
                options={options}
                value={selectedParentValue}
                handleOnChange={onChangeParent}
            />
            <CustomFieldSelector
                {...props}
                disabled={!selectedParentValue}
                options={childrenValues}
                value={selectedChildrenValues as any}
                handleOnChange={onChangeChildren}
                fieldData={{ ...fieldData, multiple: true, placeholder: formatMessage("Select values") }}
            />
        </div>
    );
};
